import React, { useEffect } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
  PasswordTextInputBase,
  CheckboxBase,
} from "@reusejs/react";
import GoogleSvg from "../../Icons/GoogleSvg";
import {
  adminLogin,
  authorize,
  getAdminByEmail,
  getUser,
  initiateGoogleLogin,
  requestVerification,
} from "services";
import { setAdminTokens, setAdminUser, webStore } from "store";

export default function LoginForm(props: any) {
  const form = useBetaForm({
    email: "",
    password: "",
    // email: "manasa@betalectic.com",
    // password: "BrInDtASeRag",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    password: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const hanldeSubmit = async () => {
    try {
      if (form.validate()) {
        const data = await adminLogin(form);

        webStore.dispatch(setAdminTokens(data));

        const user = await authorize();

        try {
          const email = form.getField("email");
          const response: any = await getAdminByEmail(email);

          if (response) {
            webStore.dispatch(setAdminUser({ uuid: response?.data[0]?.uuid }));
          }
        } catch (err) {
          console.log("error", err);
        }

        // webStore.dispatch(setAdminUser(user));

        if (props.onAction) {
          props.onAction("no");
        }
        props.router.push("/");
      }
    } catch (error: any) {}
  };

  return (
    <div className="mt-6 space-y-4">
      <div className="">
        <TextInputBase
          labelBaseProps={{
            label: "Email*",
          }}
          name={"email"}
          onChange={(val) => form.setField("email", val)}
          placeholder={"Enter your email"}
          type={"text"}
          error={
            form.errors.get("email") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("email")[0]}
              </p>
            ) : null
          }
          value={form.getField("email")}
          htmlFor={"email"}
        />
      </div>

      <div className="space-y-1">
        <label
          htmlFor="password"
          className="block text-sm font-medium text-gray-700"
        >
          Password
        </label>
        <div className="mt-1">
          <PasswordTextInputBase
            htmlFor={"password"}
            name="password"
            onChange={(val) => form.setField("password", val)}
            type="password"
            value={form.getField("password")}
            placeholder="Password"
            error={
              form.errors.get("password") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("password")[0]}
                </p>
              ) : null
            }
          />
        </div>
      </div>

      <div className="flex justify-between items-center hidden">
        <div className="text-xs lg:text-sm">
          <a
            href="/forgot-password"
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            Forgot password
          </a>
        </div>
      </div>

      <div className="flex flex-col space-y-4">
        <ButtonBase
          variant="primary"
          label="Sign in"
          onClick={hanldeSubmit}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
      </div>
    </div>
  );
}
